module.exports = __webpack_public_path__ + "img/roland-clark.576c8da7.jpg";